






























































import Vue from 'vue';
import { mapGetters } from 'vuex';
import pxButton from '@/dex-shared/components/px-button.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import states from '@/dex-shared/assets/states.json';

export default Vue.extend({
  components: {
    pxButton,
    pxCard,
  },

  data() {
    return {
      creating: true,
      pushing: false,
      states: states,
    };
  },

  computed: {
    ...mapGetters({
      institution: 'currentInstitution',
    }),
    institutionTitle() {
      if (this.institution && this.institution.title)
        return this.institution.title;
      else return '';
    },
  },

  watch: {
    institutionTitle() {
      const matches = this.institutionTitle.match(/\b([A-Z])/g);
      let acronym;
      if (matches && matches.length > 0) {
        acronym = matches.join('');
      }
      this.institution.acronym = acronym;
    },
  },

  async created() {
    this.creating = this.$route.name === 'institution_create';
    if (this.creating) {
      this.$store.commit('SET_EMPTY_INSTITUTION');
    } else {
      let institutionId = parseInt(this.$route.params.institutionId);
      await this.$store.dispatch('PULL_INSTITUTION', institutionId);
      //TODO no institution found
    }
  },

  methods: {
    pushInstitution: async function() {
      //TODO check if institution already exists
      if (this.pushing === false) {
        this.pushing = true;
        await this.$store.dispatch('PUSH_INSTITUTION', this.institution);
        this.pushing = false;
        this.$router.push(`/instituicoes`);
      }
    },
    goHome() {
      this.$router.push('/instituicoes');
    },
  },
});
